export default class Filter<T> {
    defaultMemoizeStructure: T  

    constructor(defaultMemoizeStructure: T){
        this.defaultMemoizeStructure = {...defaultMemoizeStructure}
    }

    getMemoizedData = (key:string, defaultData:any) => {
		return (typeof this.defaultMemoizeStructure[key] !== 'undefined') ? this.defaultMemoizeStructure[key]: defaultData;
	}
	
	saveMemoizeData = (key:string, data:any) => {
		this.defaultMemoizeStructure[key] = data;
	}
	
    resetMemoizeData = (key:string) => {
        this.defaultMemoizeStructure[key] = void 0;
    }

    resetAllMemoizeData = () => {
        for (const key in this.defaultMemoizeStructure) {
            if (Object.prototype.hasOwnProperty.call(this.defaultMemoizeStructure, key)) {
                this.defaultMemoizeStructure[key] = void 0;
            }
        }
    }

}